<template>

  <div>

    <div :id="_uid" class="ui small modal" :class="modalSelector">
      <div class="ui header">
        Finalização do Complemento do Laudo
      </div>
      <div v-if="cert" class="content">
        <div class="ui form">
          <div class="fields">
            <div class="four wide field">
              <label class="form-label">Número do Laudo</label>
              <input :value="cert.id" readonly="readonly">
            </div>
            <div class="twelve wide field">
              <label class="form-label">Solicitante</label>
              <input :value="$store.state.auth.user.name + ' ' + $store.state.auth.user.lastName" readonly="readonly">
            </div>     
          </div>
          <div v-if="cert.complementRequest" class="fields">
            <div class="sixteen wide field">
              <label class="form-label">Responsável</label>
              <input :value="cert.complementRequest.responsible.name + ' ' + cert.complementRequest.responsible.lastName" readonly="readonly">
            </div>     
          </div>
          <div class="fields">            
            <div class="sixteen wide field">
              <label class="form-label">Observações</label>
              <textarea rows="5" v-model="comments"></textarea>
            </div>     
          </div>
        </div>
      </div>
      <div class="actions">
        <button class="ui cancel basic button">
          <i class="times icon"></i> Cancelar
        </button>              
        <button class="ui blue button" :class="{ loading: saving }" @click="onConfirm()">
          <i class="checkmark icon"></i> Confirmar
        </button>
      </div>
    </div>

  </div>
  
</template>

<script>

  import modalDialog from "@/mixins/modal-dialog"

  export default {

    name: "ComplementFinishModal",

    data() {
      return {
        comments: "",
      }
    },

    mixins: [modalDialog],

    props: ["cert"],
    
    methods: {


      async onConfirm() {
        this.emit("onConfirm", this.comments)       
      },
    },
  }

</script>
